import { render } from "./getPermission.vue?vue&type=template&id=55039aa8&scoped=true"
import script from "./getPermission.vue?vue&type=script&lang=js"
export * from "./getPermission.vue?vue&type=script&lang=js"

import "./getPermission.vue?vue&type=style&index=0&id=55039aa8&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55039aa8"]])

export default __exports__